import ProviderComponent from "./ProviderComponent";

export { ProviderComponent as default };
